import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_Please_select_the_gender_which_ELL,
  TXTWCL_WhatXs_your_genderX,
  TXTWCL_Your_Gender
} from './RMFGender.messages.json';
import GenderToggles from './components/GenderToggles/GenderToggles';

const RMFGender: React.FC = () => (
  <Container
    page={RMFGender}
    headerProps={{
      title: <Translation {...TXTWCL_Your_Gender} />
    }}
    pageTopTitle={<Translation {...TXTWCL_WhatXs_your_genderX} />}
    pageTopSubtitle={<Translation {...TXTWCL_Please_select_the_gender_which_ELL} />}
  >
    <GenderToggles />
    <CTAButton />
  </Container>
);

RMFGender.displayName = 'RMFGender';

export default RMFGender;
